export default {
  getRemProjectComboList: state => state.projectComboList,

  /* Main getters * */
  getUserProjectList: state => state.userProjectList,
  getProjectDetail: state => state.projectDetail,
  getProjectCspList: state => state.projectCspList,
  getProjectEnvs: state => state.projectEnvs,
  getEnvTab: state => state.envTab,
  getResourceUserList: state => state.resourceUserList,
  /* 좌측 Project 그리드 페이징 처리 필요값 **/
  getProjectCurrentPage: state => state.currentPage,
  getProjectPageSize: state => state.pageSize,
  getProjectPageUnit: state => state.pageUnit,
  getProjectRecords: state => state.records,
  /* 우측 유저 목록 그리드 페이징 처리 필요값 **/
  getUserCurrentPage: state => state.userCurrentPage,
  getUserPageSize: state => state.userPageSize,
  getUserPageUnit: state => state.userPageUnit,
  getUserRecords: state => state.userRecords,

  /* Popup getters * */
  getServiceMembersList: state => state.serviceMembersList,
  getAllUserList: state => state.allUserList,
};



// WEBPACK FOOTER //
// ./src/vuex/rem/project/projectGetters.js